import { Videos as VideoChatLayout } from 'src/routes/video-landing-page/videos-chat-layout';

export function Videos() {
  return <VideoChatLayout />;
}
